
import { Component } from 'react'
var React = require('react')
var Forecast = require('react-forecast')
 
class Weather extends Component{
  render() {
    return (
      <Forecast latitude={38.50} longitude={-90.64} name='Eureka, MO' />
    );
  }
};

export default Weather


// WEBPACK FOOTER //
// ./src/components/multi/Weather.js